import { render, staticRenderFns } from "./overRitht.vue?vue&type=template&id=d7b59652&scoped=true"
import script from "./overRitht.vue?vue&type=script&lang=js"
export * from "./overRitht.vue?vue&type=script&lang=js"
import style0 from "./overRitht.vue?vue&type=style&index=0&id=d7b59652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b59652",
  null
  
)

export default component.exports